import {ConfigApi, MultistoreLayoutType} from "../../../../services/Api/types";
import MultistoreBrandListHomePage from "./components/BrandList/MultistoreBrandListHomePage";
import MultistoreWithMapHomePage from "./components/HomeWithMap/MultistoreWithMapHomePage";
import StoreUtils from "../../../../services/Store/StoreUtils";

interface Props {
    config: ConfigApi;
}

const MultistoreHomePage = ({config}: Props) => {
    const layout = StoreUtils.getMultistoreLayoutType(config);

    if (layout === MultistoreLayoutType.BRAND_LIST) return <MultistoreBrandListHomePage config={config}/>;

    return <MultistoreWithMapHomePage config={config}/>
}

export default MultistoreHomePage;